import * as yup from 'yup';

export const FORGOT_PASSWORD_SCHEMA = yup.object().shape({
    email: yup.string().email('Email must be a valid email.').required()
});

export const CHANGE_PASSWORD_SCHEMA = yup.object().shape({
    email: yup.string().email('Email must be a valid email.').required(),
    token: yup.string().required(),
    password: yup.string().required(),
    password_confirmation: yup.string().required()
});
